import Facebook from '../../assets/Facebook.svg';
import EmailIcon from '../../assets/iconemail.png';
import Instagram from '../../assets/Instagram.svg';
import LinkedIn from '../../assets/LinkedIn.svg';
import SensforgeLogo from '../../assets/sensforge-logo.png';
import Tiktok from '../../assets/tiktok.svg';
import Xicon from '../../assets/Xicon.svg';
import Youtube from '../../assets/Youtube.svg';
import { type FC } from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 1.5rem;
  background: #faf5f3;
  @media (min-width: 768px) {
    padding: 5rem;
  }
`;

const FooterMain = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 38px;
  border-radius: 20px;
  background: #f1eae5;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  margin-bottom: 0;
`;

const LogoImg = styled.img`
  margin-right: 0.5rem;
  margin-bottom: 18px;
  width: 200px;
  height: 40px;
`;

const Contact = styled.div`
  font-size: 1rem;
  color: #333;
  margin-top: 0.5rem;
`;

const ContactLabel = styled.p`
  color: #F87B15;
`;

const SocialRow = styled.div`
  display: flex;
  margin-top: 1.25rem;
`;

const SocialLink = styled.a`
  margin-right: 0.5rem;
  &:last-child {
    margin-right: 0;
  }
`;

const SocialIcon = styled.img`
  width: 42px;
  @media (min-width: 768px) {
    width: 44px;
  }
`;

const NavSection = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-left: auto;
  margin-top: 1rem;
  @media (min-width: 768px) {
    margin-top: 0;
  }
`;

const NavCol = styled.div`
  display: flex;
  flex-direction: column;
  width: 120px;
  line-height: 2;
  margin-right: 2rem;
  @media (min-width: 768px) {
    margin-right: 0;
  }
`;

const NavLink = styled.a`
  color: #333;
  text-decoration: none;
  &:hover {
    color: #F87B15;
  }
`;

const FooterBottom = styled.div`
  font-size: 0.875rem;
  color: #666;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px 0 10px;
  @media (min-width: 768px) {
    flex-direction: row;
    padding-top: 20px;
  }
`;

const PolicyLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  margin-bottom: 20px;
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
  }
`;

const PolicyLink = styled.a`
  text-decoration: underline;
  color: #666;
  text-align: center;
  padding: 0 1.5rem;
  &:hover {
    color: #F87B15;
  }
  @media (min-width: 768px) {
    padding: 0 0.25rem;
  }
`;

export const CommonFooter: FC = () => {
  return (
    <FooterContainer>
      <FooterMain>
        {/* Left section */}
        <Left>
          <LogoLink href="#">
            <LogoImg src={SensforgeLogo} alt="Sensforge" />
          </LogoLink>
          <Contact>
            <ContactLabel>Contact:</ContactLabel>
            <p>
              <img src={EmailIcon} style={{ width: 24, height: 16, display: 'inline-block', marginRight: 12, verticalAlign: 'middle' }} alt="email" />
              <a href="mailto:info@sensforge.com" style={{ color: '#000' }}>info@sensforge.com</a>
            </p>
          </Contact>
          <SocialRow>
            <SocialLink href="https://www.facebook.com/sensforgecameras/">
              <SocialIcon src={Facebook} alt="Facebook" />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/sensforge/">
              <SocialIcon src={Instagram} alt="Instagram" />
            </SocialLink>
            <SocialLink href="https://x.com/sensforgecamera">
              <SocialIcon src={Xicon} alt="X" />
            </SocialLink>
            <SocialLink href="https://www.linkedin.com/company/sensforge/">
              <SocialIcon src={LinkedIn} alt="LinkedIn" />
            </SocialLink>
            <SocialLink href="https://www.youtube.com/@sensforge">
              <SocialIcon src={Youtube} alt="Youtube" />
            </SocialLink>
            <SocialLink href="https://www.tiktok.com/@sensforge">
              <SocialIcon src={Tiktok} alt="Tiktok" />
            </SocialLink>
          </SocialRow>
        </Left>
        {/* Right section */}
        <NavSection>
          <NavCol>
            <NavLink href="/index">Home</NavLink>
            <NavLink href="/indoor-pan-tilt-camera">Product</NavLink>
            <NavLink href="/support">Support</NavLink>
            <NavLink href="/app">App</NavLink>
          </NavCol>
          <NavCol>
            <NavLink href="/blog">Blog</NavLink>
            <NavLink href="/about">About Us</NavLink>
            <NavLink href="/careers">Careers</NavLink>
            <NavLink href="/community">Community</NavLink>
          </NavCol>
        </NavSection>
      </FooterMain>
      <FooterBottom>
        <span>&copy; 2025 Sensforge Inc. All rights reserved.</span>
        <PolicyLinks>
          <PolicyLink href="/privacy-policy">Privacy Policy</PolicyLink>
          <PolicyLink href="/terms-of-use">Terms of Use</PolicyLink>
          <PolicyLink href="/security-and-trust">Security & Trust</PolicyLink>
          <PolicyLink href="/cookie-policy">Cookie Policy</PolicyLink>
        </PolicyLinks>
      </FooterBottom>
    </FooterContainer>
  );
};
